import ReactGA from 'react-ga4';

const UseAnalyticsEvent = () => {
    const eventTracker = (category, action, label = "No Label") => {
        ReactGA.event({ category, action, label });
    }
    return eventTracker;
}
export default UseAnalyticsEvent;

// import { initializeApp } from "firebase/app";
// import { getAnalytics, logEvent } from "firebase/analytics";

// const firebaseConfig = {
//     apiKey: "AIzaSyCqOCUn7yw-xJ8rmjPus580iyfTgPm9htY",
//     authDomain: "parksmart-dashboard.firebaseapp.com",
//     projectId: "parksmart-dashboard",
//     storageBucket: "parksmart-dashboard.appspot.com",
//     messagingSenderId: "609416546985",
//     appId: "1:609416546985:web:94bbeca71a29faf05c37b8",
//     measurementId: "G-3SJBV6KZ0E"
// };
// const UseAnalyticsEvent = () => {

//     const eventTracker = (category, action, label = "No Label") => {
//         const app = initializeApp(firebaseConfig);
//         const analytics = getAnalytics(app);
//         logEvent(analytics, category, { name: action });
//         // logEvent(analytics, action);
//     }
//     return eventTracker;
// }
// export default UseAnalyticsEvent;

